import React from 'react';
import styles from './LandingPage.module.css';

// Components
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import EcosystemFlow from './components/EcosystemFlow';
import CapabilitiesSection from './components/CapabilitiesSection';
import EngineeringBanner from './components/EngineeringBanner';
import LeadersSection from './components/LeadersSection';
import EnginesSection from './components/EnginesSection';
import TestimonialsSection from './components/TestimonialsSection';
import WhyIndiaSection from './components/WhyIndiaSection';
import EnterpriseTrustSection from './components/EnterpriseTrustSection';
import CtaSection from './components/CtaSection';
import MarqueeStrip from './components/MarqueeStrip';

const LandingPage = () => {
  return (
    <div className={styles.landingPageContainer}>
      <HeroSection />
      <StatsSection />
      <MarqueeStrip />
      <EcosystemFlow />
      <CapabilitiesSection />
      <EngineeringBanner />
      {/* <LeadersSection /> */}
      <EnginesSection />
      <TestimonialsSection />
      <WhyIndiaSection />
      <EnterpriseTrustSection />
      <CtaSection />
    </div>
  );
};

export default LandingPage;
